module.exports = __webpack_public_path__ + "img/4d688caf3ba2489ebd5551bb563f7cfe-640.c7dcc10c.jpg";